export default "<div style=\"text-align:center;color:red;padding-top:70px;\" *ngIf=\"showError\" class=\"show-error\">{{ errorMessage }}</div>\r\n"